import api from '@/utils/http/axios'
import store from '@/store'

export default {
  /**
  * 获取转账汇款申报表格数据
  * @param {string} accNo 账号
  * @param {string} type 申报状态
  * @param {string} beginDate 开始日期
  * @param {string} endDate 结束日期
  * @param {number} turnPageBeginPos 第几条数据
  * @param {number} turnPageShowNum 每页数量
  * @param {number} currentBusinessCode 10101300
  */
  getDeclareTableData (params = {}, config = {}) {
    return api.post('/api/pay/report/page', params, {
      convertPageNumAndSize: true,
      ...config
    }, 'URLEncoded')
  },
  /**
  * 获取汇入汇款申报详情
  * @param {string} accountNo 账号
  * @param {string} reportId 申报单号
  */
  getDeclareDetail (params = {}, config = {}) {
    return api.post('/api/pay/report/detail', params, config, 'URLEncoded')
  },
  /**
  * 更新汇入汇款申报信息
  * @param {string} reportId 申报单号
  * @param {string} accountNo 账号
  * @param {number} recvBusinessType 收款方企业性质
  * @param {string} relation 与收款方关系
  * @param {number} documents 资金证明材料
  */
  updateDeclare (params = {}, config = {}) {
    return api.post(`/api/pay/report/update?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  }
}
